import React from "react";
import type { ViewComponent } from "@frui.ts/views/dist";
import { registerView } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import { Col, Form, Modal } from "react-bootstrap";
import FakeInput from "@edaz/edazkit/controls/FakeInput";
import EmailBlacklistDetailViewModel from "viewModels/administration/emailBlacklist/emailBlacklistDetailViewModel";
import EditableDetailView from "../../common/editableDetailView";
import EmailBlacklistForm from "./emailBlacklistForm";
import { formatDateTime } from "utils/localizations";
import { emptyValue } from "utils/emptyValue";

const EmailBlacklistDetailView: ViewComponent<EmailBlacklistDetailViewModel> = observer(({ vm }) => {
  // Editace - původní styl s EditableDetailView
  if (vm.isEditable) {
    return (
      <Modal scrollable show={true} onHide={vm.requestClose} centered>
        <Modal.Body>
          <EditableDetailView vm={vm} titleClassName="text-left" form={<EmailBlacklistForm vm={vm} isCreate={false} />} />
        </Modal.Body>
      </Modal>
    );
  }

  // Read-only detail - se sekcemi
  return (
    <Modal scrollable show={true} onHide={vm.requestClose} centered size="lg">
      <Modal.Header className="d-flex justify-content-between align-items-center">
        <Modal.Title>{vm.translate("detail")}</Modal.Title>
        <button type="button" className="close p-0 ml-auto" onClick={vm.requestClose} style={{ fontSize: "1rem" }}>
          <span aria-hidden="true">&times;</span>
        </button>
      </Modal.Header>
      <Modal.Body>
        {/* Sekce Detail položky - modré záhlaví */}
        <div className="rounded bg-light">
          <div className="bg-secondary px-4 py-3 rounded-top text-white">
            <span className="font-size-lg font-weight-bold">{vm.translate("detail")}</span>
          </div>
          <div className="px-4 pt-4 pb-2">
            <EmailBlacklistForm vm={vm} isCreate={false} />
          </div>
        </div>

        {/* Sekce Provozní údaje - šedé záhlaví */}
        {vm.item && (
          <div className="rounded bg-light mt-4">
            <div className="bg-secondary px-4 py-3 rounded-top text-white">
              <span className="font-size-lg font-weight-bold">{vm.translate("operatingData")}</span>
            </div>
            <div className="px-4 pt-4 pb-2">
              <Form.Row>
                <Form.Group as={Col} md={6}>
                  <Form.Label>{vm.translateSubAttribute("emailBlacklist", "createdAt")}</Form.Label>
                  <FakeInput
                    target={vm.item}
                    property="createdAt"
                    valueFormatter={value => (value ? formatDateTime(value) : emptyValue)}
                  />
                </Form.Group>
                <Form.Group as={Col} md={6}>
                  <Form.Label>{vm.translateSubAttribute("emailBlacklist", "createdBy")}</Form.Label>
                  <FakeInput target={vm.item} property="createdBy" valueFormatter={value => value ?? emptyValue} />
                </Form.Group>
              </Form.Row>
              <Form.Row>
                <Form.Group as={Col} md={6}>
                  <Form.Label>{vm.translateSubAttribute("emailBlacklist", "updatedAt")}</Form.Label>
                  <FakeInput
                    target={vm.item}
                    property="updatedAt"
                    valueFormatter={value => (value ? formatDateTime(value) : emptyValue)}
                  />
                </Form.Group>
                <Form.Group as={Col} md={6}>
                  <Form.Label>{vm.translateSubAttribute("emailBlacklist", "updatedBy")}</Form.Label>
                  <FakeInput target={vm.item} property="updatedBy" valueFormatter={value => value ?? emptyValue} />
                </Form.Group>
              </Form.Row>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
});

registerView(EmailBlacklistDetailView, EmailBlacklistDetailViewModel);
